export const HIDE_ERROR = 'HIDE_ERROR';
export const ADD_ERROR = 'ADD_ERROR';


export const addError = (list) => (dispatch, getState) => {
    dispatch(_addError(list));
}

export const hideError = () => (dispatch, getState) => {
    dispatch(_hideError());
}


const _addError = ( list ) => ({
    type: ADD_ERROR,
    payload: {
        list
    }
})


const _hideError = () => ({
    type: HIDE_ERROR,
    payload: {
    }
})
